<div class="aeg-wallet-details">
    <vl-info-tile tag-name="div" :title="title">
        <template v-slot:headerextension>
            <vl-button mod-primary icon="plus-circle" :mod-disabled="errorLoading" @click="goToTopUpWallet" mod-icon-after>
                {{ isMobileWidth ? 'Opladen' : 'Saldo opladen' }}
            </vl-button>
        </template>
        <template v-if="loading">
            <div class="aeg-wallet-details__loading">
                <vl-loader message="De gegevens worden geladen. Even geduld, a.u.b." />
            </div>
        </template>
        <template v-else-if="errorLoading">
            <div class="aeg-billing-details__error">
                <div class="aeg-billing-details__error-text">
                    <vl-icon icon="warning" mod-error />
                    Er ging iets mis bij het ophalen van uw eLys-saldo.    
                </div>
                <div>
                    <vl-link @click.prevent="reload" mod-icon-before icon="text-redo" mod-block>
                        Opnieuw proberen
                    </vl-link>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="aeg-wallet-details__image">
                <vl-icon icon="wallet" mod-large />
            </div>
            <div class="aeg-wallet-details__amount">
                {{ formatCurrency(serviceWallet.walletAmount) }}
            </div>    
        </template>
    </vl-info-tile>
</div>